interface WorkGroupEmptyStateProps {
  title: string;
  description?: string;
}

export function WorkGroupEmptyState({ title, description }: WorkGroupEmptyStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-border bg-muted/30 p-8 text-center">
      <p className="text-sm font-medium text-foreground">{title}</p>
      {description ? <p className="mt-2 text-sm text-muted-foreground">{description}</p> : null}
    </div>
  );
}
